{
  "internalPortal": {
    "components": {
      "sibContracts": {
        "title": "SIB Contracts",
        "actions": {
          "displayContractsAcrossSubsidiaries": "Display contracts across subsidiaries"
        },
        "details": {
          "title": "SIB Contract details",
          "editTitle": "SIB Contract details - Edit",
          "editContractDetails": "Edit contract details",
          "sections": {
            "contractDetails": "Contract details",
            "contractDetailsTooltip": "Editable contract details for this SIB contract.",
            "contingencyFee": "Contingency fee",
            "contingencyFeeTooltip": "Contingency fee periods for this SIB contract."
          },
          "contingencyFee": {
            "duration": "Duration",
            "fee": "Fee",
            "months": "Months",
            "feeLabel": "{{ordinal}} Contingency fee",
            "rangeSummary": "{{start}}-{{end}} Months, {{fee}}% Fee",
            "previewRange": "{{start}} – {{end}} mo",
            "previewFee": "{{fee}}% fee",
            "add": "+ Add Contingency fee",
            "remove": "Remove"
          },
          "success": "SIB Contract updated successfully",
          "error": "Failed to update SIB Contract",
          "loadError": "Failed to load SIB Contract details",
          "audits": {
            "title": "Audits ({{count}})"
          }
        },
        "noData": {
          "withFilters": {
            "title": "No contracts match your filters",
            "description": "Try adjusting your filters to find what you're looking for"
          },
          "withoutFilters": {
            "title": "No contracts found",
            "description": "No SIB contracts found for this organization."
          }
        }
      }
    }
  }
}
